import { Injectable } from '@angular/core';

@Injectable()
export class StorageService {

  getItem(key: string, isLocalStorage: boolean = false): string | undefined | null {
    if (isLocalStorage) {
      return localStorage.getItem(key);
    }

    return sessionStorage.getItem(key);
  }

  removeItem(key: string, isLocalStorage: boolean = false): void {
    if (isLocalStorage) {
      if (!this.getItem(key, true)) {
        return;
      }

      localStorage.removeItem(key);
    }

    if (!this.getItem(key)) {
      return;
    }

    sessionStorage.removeItem(key);
  }

  setItem(key: string, data: string, isLocalStorage: boolean = false): void {
    if (isLocalStorage) {
      localStorage.setItem(key, data);
      return;
    }

    sessionStorage.setItem(key, data);
  }

  clear(isLocalStorage: boolean = false): void {
    if (isLocalStorage) {
      localStorage.clear();
      return;
    }

    sessionStorage.clear();
  }
}
